// Which BPMN elements an entity/application focus layer applies to.
//
// Focus highlights process elements that interact with the focused entity or
// application. Both tasks AND events qualify — each can carry entity_refs and
// be linked to an application — but gateways, flows, lanes, etc. never do.
//
// Kept in its own module (depending only on bpmn-js' pure ModelUtil) so it is
// unit-testable without loading the full bpmn-js modeler that helpers.ts pulls
// in. We call `is()` directly rather than reusing helpers.elementIsTask/Event
// for that reason.
import type { BpmnElement } from "bpmn-js/lib/model/Types";
import { is } from "bpmn-js/lib/util/ModelUtil";

export const elementIsFocusable = (element: BpmnElement): boolean =>
    is(element, "bpmn:Task") || is(element, "bpmn:Event");
